import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
  selector: 'app-search-careprovider-unit-item-labels',
  templateUrl: './search-careprovider-unit-item-labels.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCareproviderUnitItemLabelsComponent {
  public isDigital = input<boolean>(null);
  public isBoosted = input<boolean>(null);
  public isAbroad = input<boolean>(null);
}
